import { RouteObject } from "react-router-dom";
import { PurchaseOrdersPage } from "src/routes/developments/purchase-orders/PurchaseOrdersPage";
import { NotFound } from "src/routes/NotFound";
import { TradePartnersPage } from "src/routes/trade-partners/TradePartnersPage";
import { GlobalBidContractsPage } from "src/routes/trades/bid-contracts/GlobalBidContractsPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import {
  tradesBidContractsRoute,
  tradesPurchaseOrdersRoute,
  tradesRoute,
  tradesTradePartnersRoute,
} from "src/routing/domains/tradesPaths";

/**
 * `/trades/*` route tree (excluding `/trades/bid-packages/*` — see `bidPackages.ts`).
 *
 * Role: data router domain route.
 *
 * Legacy stack (pages still use `PageHeader`, not Beam page layouts):
 * `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 * When pages move to `PageHeaderLayout` / `GridTableLayout`, switch to
 * `AppShell` → `BeamNavbarLayout` → page (see `domains/projects.ts`).
 *
 * Path constants live in `tradesPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 */
const tradesDomainRoute: RouteObject = {
  path: tradesRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { path: tradesTradePartnersRoute.path, Component: TradePartnersPage },
            { path: tradesPurchaseOrdersRoute.path, Component: TradesPurchaseOrdersPage },
            { path: tradesBidContractsRoute.path, Component: GlobalBidContractsPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/** Global trades PO list — same page as finances/development POs with trades chrome flags. */
function TradesPurchaseOrdersPage() {
  return <PurchaseOrdersPage isGlobal isTrades />;
}

/**
 * Migrated `/trades/*` route trees registered in `Router.tsx`.
 */
export const tradesRoutes = [tradesDomainRoute];
